import React, { useEffect, useMemo, useState } from "react";
import "./modalicfes.css";
import Cuadernillo from "./cuadernillo/cuadernillo";
import Seccion from "./seccion/seccion";
import Preguntas from "./preguntas/preguntas";
import {
  crearCuadernillo,
  crearSeccion,
  crearPregunta,
  obtenerCuadernilloPorId,
  obtenerCuadernillos,
  obtenerSecciones,
  obtenerTodasPreguntasPorCuadernillo,
  actualizarPregunta,
} from "../../../../funtions";

const modeLabels = {
  cuadernillo: "Crear cuadernillo",
  section: "Crear seccion",
  question: "Crear pregunta",
};

function ModalIcfes({
  isOpen,
  children,
  onClose,
  cuadernilloId = "default",
}) {
  const initialCuadernilloId = cuadernilloId && cuadernilloId !== "default" ? cuadernilloId : "";
  const [mode, setMode] = useState(initialCuadernilloId ? "section" : "cuadernillo");
  const [cuadernilloIdState, setCuadernilloIdState] = useState(initialCuadernilloId);
  const [cuadernilloName, setCuadernilloName] = useState("");
  const [sections, setSections] = useState([]);
  const [sectionName, setSectionName] = useState("");
  const [questionMode, setQuestionMode] = useState("individual");
  const [questionText, setQuestionText] = useState("");
  const [contextType, setContextType] = useState("texto");
  const [contextText, setContextText] = useState("");
  const [referenceText, setReferenceText] = useState("");
  const [imageHeader, setImageHeader] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [selectedImageUrl, setSelectedImageUrl] = useState("");
  const [imageLibraryText, setImageLibraryText] = useState("");
  const [answerA, setAnswerA] = useState("");
  const [answerB, setAnswerB] = useState("");
  const [answerC, setAnswerC] = useState("");
  const [answerD, setAnswerD] = useState("");
  const [correctAnswer, setCorrectAnswer] = useState("a");
  const [selectedSection, setSelectedSection] = useState("");
  const [questions, setQuestions] = useState([]);
  const [activeContextId, setActiveContextId] = useState("");
  const [editingQuestionId, setEditingQuestionId] = useState("");
  const [editingQuestionContextId, setEditingQuestionContextId] = useState("");
  const [url, setUrl] = useState("");
  const [cuadernillos, setCuadernillos] = useState([]);
  const [loading, setLoading] = useState(false);

  const sectionOptions = useMemo(
    () => sections.map((section) => ({
      value: section.id,
      label: section.name,
    })),
    [sections]
  );

  const hasCuadernillo = Boolean(cuadernilloIdState);
  const hasSections = sections.length > 0;

  const resetQuestionForm = ({ preserveContext = false, preserveSection = false } = {}) => {
    setQuestionText("");
    if (!preserveContext) {
      setContextType("none");
      setContextText("");
      setReferenceText("");
      setImageHeader("");
      setImageUrl("");
      setSelectedImageUrl("");
      setImageLibraryText("");
      setActiveContextId("");
    }
    setAnswerA("");
    setAnswerB("");
    setAnswerC("");
    setAnswerD("");
    setCorrectAnswer("a");
    setUrl("");
    setEditingQuestionId("");
    setEditingQuestionContextId("");
    if (!preserveSection) {
      setSelectedSection(sections[0]?.id || "");
    }
  };

  const loadCuadernillos = async () => {
    try {
      const data = await obtenerCuadernillos();
      setCuadernillos(data);
    } catch (error) {
      console.error("Error cargando cuadernillos:", error);
    }
  };

  const handleSelectExistingCuadernillo = async (id) => {
    setCuadernilloIdState(id);
    const selected = cuadernillos.find((item) => item.id === id);
    setCuadernilloName(selected?.nombre || "");
    setSections([]);
    setQuestions([]);
    setSelectedSection("");
    resetQuestionForm();
    setMode("section");
    await loadCuadernilloData(id);
  };

  const loadCuadernilloData = async (id) => {
    if (!id) return;

    try {
      setLoading(true);
      const cuadernillo = await obtenerCuadernilloPorId(id);
      if (cuadernillo) {
        setCuadernilloName(cuadernillo.nombre || "");
      }

      const fetchedSections = await obtenerSecciones(id);
      const normalizedSections = fetchedSections.map((section) => ({
        id: section.id || section.sectionId || "",
        name: section.nombre || section.name || "",
        ...section,
      }));
      setSections(normalizedSections);
      setSelectedSection(normalizedSections[0]?.id || "");

      const fetchedQuestions = await obtenerTodasPreguntasPorCuadernillo(id);
      setQuestions(
        fetchedQuestions.map((question) => {
          const normalizedOptions = question.options || question.opciones || {};
          const normalizedContextType = question.contextType || question.contextoTipo || (question.imageUrl ? "figura" : (question.contextText || question.contexto ? "texto" : "none"));

          return {
            ...question,
            type: question.type || 'question',
            contextId: question.contextId || null,
            options: normalizedOptions,
            reference: question.reference || "",
            imageHeader: question.imageHeader || "",
            contextType: normalizedContextType,
            contextText: question.contextText || question.contexto || "",
            imageUrl: question.imageUrl || "",
            correct: question.correcta || question.correct || "a",
            correctText: normalizedOptions[question.correcta || question.correct || "a"] || "",
            text: question.texto || question.text || "",
            url: question.url || "",
          };
        })
      );
    } catch (error) {
      console.error("Error cargando datos del cuadernillo:", error);
      alert("Error al cargar los datos del cuadernillo. Intenta de nuevo.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isOpen) {
      loadCuadernillos();
      if (cuadernilloIdState) {
        loadCuadernilloData(cuadernilloIdState);
      }
    }
  }, [isOpen, cuadernilloIdState]);

  const startEditingQuestion = (question) => {
    const normalizedOptions = question.options || question.opciones || {};
    const normalizedContextType = question.contextType || question.contextoTipo || (question.imageUrl ? "figura" : (question.contextText || question.contexto ? "texto" : "none"));
    const derivedMode = question.type === 'context' || question.contextId ? 'conjunto' : 'individual';

    setEditingQuestionId(question.id);
    setEditingQuestionContextId(question.contextId || "");
    setQuestionMode(derivedMode);
    setActiveContextId(question.contextId || "");
    setQuestionText(question.text || question.texto || "");
    setContextType(normalizedContextType);
    setContextText(question.contextText || question.contexto || "");
    setReferenceText(question.reference || "");
    setImageHeader(question.imageHeader || "");
    setImageUrl(question.imageUrl || "");
    setSelectedImageUrl(question.imageUrl || "");
    setImageLibraryText(question.imageUrl ? question.imageUrl : "");
    setAnswerA(normalizedOptions.a || "");
    setAnswerB(normalizedOptions.b || "");
    setAnswerC(normalizedOptions.c || "");
    setAnswerD(normalizedOptions.d || "");
    setCorrectAnswer(question.correct || question.correcta || "a");
    setSelectedSection(question.sectionId || "");
    setUrl(question.url || "");
    setMode("question");
  };

  const cancelEditQuestion = () => {
    resetQuestionForm();
  };

  const handleQuestionModeChange = (value) => {
    setQuestionMode(value);

    if (value === "individual") {
      setContextType("texto");
      setContextText("");
      setReferenceText("");
      setImageHeader("");
      setImageUrl("");
      setSelectedImageUrl("");
      setImageLibraryText("");
      setActiveContextId("");
      return;
    }

    setContextType("texto");
    setContextText("");
    setReferenceText("");
    setImageHeader("");
    setImageUrl("");
    setSelectedImageUrl("");
    setImageLibraryText("");
    setActiveContextId("");
  };

  const handleContextTypeChange = (value) => {
    setContextType(value);
    setReferenceText("");
    setImageHeader("");
    setImageUrl("");
    setSelectedImageUrl("");
    setImageLibraryText("");
    if (value === "none") {
      setContextText("");
      setActiveContextId("");
    } else {
      setActiveContextId("");
    }
  };

  const handleImageLibraryChange = (value) => {
    setImageLibraryText(value);
    const options = value
      .split(/\r?\n/)
      .map((line) => line.trim())
      .filter(Boolean);

    if (options.length === 0) {
      setImageUrl("");
      setSelectedImageUrl("");
      return;
    }

    if (!selectedImageUrl || !options.includes(selectedImageUrl)) {
      const firstOption = options[0];
      setSelectedImageUrl(firstOption);
      setImageUrl(firstOption);
    }
  };

  const handleImageSelectionChange = (value) => {
    setSelectedImageUrl(value);
    setImageUrl(value);
  };

  const updateQuestion = async () => {
    if (!editingQuestionId) return;

    if (!hasSections) {
      alert("Primero crea una seccion para asignar la pregunta.");
      return;
    }

    if (!selectedSection) {
      alert("Selecciona una seccion.");
      return;
    }

    if (!questionText.trim()) {
      alert("Escribe el texto de la pregunta.");
      return;
    }

    if (!answerA.trim() || !answerB.trim() || !answerC.trim() || !answerD.trim()) {
      alert("Completa todas las respuestas A, B, C y D.");
      return;
    }

    const groupedQuestion = questionMode === "conjunto" || Boolean(editingQuestionContextId);
    const selectedContext = contextOptions.find((option) => option.id === activeContextId);
    const groupedContext = selectedContext || null;

    if (groupedQuestion && !groupedContext && contextType === "texto" && !contextText.trim()) {
      alert("Escribe el texto base del conjunto.");
      return;
    }

    if (groupedQuestion && !groupedContext && contextType === "figura" && !imageHeader.trim()) {
      alert("Escribe el encabezado de la imagen.");
      return;
    }

    if (groupedQuestion && !groupedContext && contextType === "figura" && !imageUrl.trim()) {
      alert("Selecciona una imagen para el conjunto.");
      return;
    }

    try {
      setLoading(true);

      const preguntaData = {
        sectionId: selectedSection,
        texto: questionText.trim(),
        opciones: {
          a: answerA.trim(),
          b: answerB.trim(),
          c: answerC.trim(),
          d: answerD.trim(),
        },
        correcta: correctAnswer,
        type: 'question',
        contextId: groupedContext ? groupedContext.id : null,
        contextType: groupedContext ? groupedContext.contextType : (groupedQuestion ? contextType : null),
        contextText: groupedContext && groupedContext.contextType === "texto"
          ? groupedContext.contextText || null
          : groupedQuestion && contextType === "texto"
            ? contextText.trim() || null
            : null,
        reference: groupedContext
          ? groupedContext.reference || null
          : groupedQuestion && contextType === "texto"
            ? referenceText.trim() || null
            : null,
        imageHeader: groupedContext && groupedContext.contextType === "figura"
          ? groupedContext.imageHeader || null
          : groupedQuestion && contextType === "figura"
            ? imageHeader.trim() || null
            : null,
        imageUrl: groupedContext && groupedContext.contextType === "figura"
          ? groupedContext.imageUrl || null
          : groupedQuestion && contextType === "figura"
            ? imageUrl.trim() || null
            : null,
        url: url.trim() || null,
      };

      await actualizarPregunta(editingQuestionId, preguntaData);

      const updatedQuestion = {
        id: editingQuestionId,
        sectionId: selectedSection,
        text: questionText.trim(),
        options: preguntaData.opciones,
        type: 'question',
        contextId: preguntaData.contextId,
        contextType: preguntaData.contextType,
        contextText: preguntaData.contextText,
        reference: preguntaData.reference,
        imageHeader: preguntaData.imageHeader,
        imageUrl: preguntaData.imageUrl,
        correct: correctAnswer,
        correctText: preguntaData.opciones[correctAnswer],
        correcta: correctAnswer,
        url: preguntaData.url || null,
      };

      setQuestions((prev) => prev.map((item) => (item.id === editingQuestionId ? updatedQuestion : item)));
      resetQuestionForm();
      alert("Pregunta actualizada.");
    } catch (error) {
      console.error("Error al actualizar pregunta:", error);
      alert("Error al actualizar la pregunta. Intenta de nuevo.");
    } finally {
      setLoading(false);
    }
  };

  const addCuadernillo = async () => {
    const name = cuadernilloName.trim();
    if (!name) {
      alert("Escribe un nombre de cuadernillo.");
      return;
    }

    try {
      setLoading(true);
      const newCuadernillo = await crearCuadernillo({ nombre: name });
      setCuadernilloIdState(newCuadernillo.id);
      setCuadernilloName(newCuadernillo.nombre);
      setCuadernillos((prev) => [...prev, newCuadernillo]);
      setMode("section");
      await loadCuadernilloData(newCuadernillo.id);
      alert(`Cuadernillo "${name}" creado. Ahora puedes agregar secciones.`);
    } catch (error) {
      console.error("Error al crear cuadernillo:", error);
      alert("Error al crear el cuadernillo. Intenta de nuevo.");
    } finally {
      setLoading(false);
    }
  };

  const addSection = async () => {
    if (!hasCuadernillo) {
      alert("Primero crea un cuadernillo.");
      return;
    }

    const name = sectionName.trim();
    if (!name) {
      alert("Escribe un nombre de seccion.");
      return;
    }

    if (sections.some((section) => String(section.name || section.nombre || "").toLowerCase() === name.toLowerCase())) {
      alert("Ya existe una seccion con ese nombre.");
      return;
    }

    try {
      setLoading(true);

      // Guardar en Firestore
      const newSectionFromDb = await crearSeccion(cuadernilloIdState, { nombre: name });

      const newSection = {
        id: newSectionFromDb.id,
        name: newSectionFromDb.nombre,
      };

      setSections((prev) => [...prev, newSection]);
      setSectionName("");
      setSelectedSection(newSection.id);
      alert(`Seccion "${name}" creada.`);
    } catch (error) {
      console.error("Error al crear seccion:", error);
      alert("Error al crear la seccion. Intenta de nuevo.");
    } finally {
      setLoading(false);
    }
  };

  const addQuestion = async () => {
    if (!hasSections) {
      alert("Primero crea una seccion para asignar la pregunta.");
      return;
    }

    if (!selectedSection) {
      alert("Selecciona una seccion.");
      return;
    }

    if (!questionText.trim()) {
      alert("Escribe el texto de la pregunta.");
      return;
    }

    if (!answerA.trim() || !answerB.trim() || !answerC.trim() || !answerD.trim()) {
      alert("Completa todas las respuestas A, B, C y D.");
      return;
    }

    const groupedQuestion = questionMode === "conjunto";
    const selectedContext = contextOptions.find((option) => option.id === activeContextId);
    const groupedContext = selectedContext || null;
    const hasDraftContext = groupedQuestion && (
      (contextType === "texto" && contextText.trim())
      || (contextType === "figura" && (imageHeader.trim() || imageUrl.trim()))
    );

    try {
      setLoading(true);

      let contextId = groupedContext ? groupedContext.id : activeContextId;
      const hasContext = hasDraftContext;

      if (hasContext && !groupedContext && !contextId) {
        const contextPayload = {
          sectionId: selectedSection,
          texto: contextType === "texto" ? contextText.trim() || null : (imageUrl.trim() || null),
          opciones: {},
          correcta: null,
          type: 'context',
          contextId: null,
          contextType,
          contextText: contextType === "texto" ? contextText.trim() || null : null,
          reference: referenceText.trim() || null,
          imageHeader: contextType === "figura" ? imageHeader.trim() || null : null,
          imageUrl: contextType === "figura" ? imageUrl.trim() || null : null,
          url: null,
        };

        const contextFromDb = await crearPregunta(contextPayload);
        contextId = contextFromDb.id;
        setActiveContextId(contextId);

        const parentQuestion = {
          id: contextFromDb.id,
          sectionId: selectedSection,
          text: contextType === "texto" ? contextText.trim() : (imageHeader.trim() || imageUrl.trim() || "Figura"),
          options: {},
          type: 'context',
          contextId: null,
          contextType,
          contextText: contextType === "texto" ? contextText.trim() || null : null,
          reference: referenceText.trim() || null,
          imageHeader: contextType === "figura" ? imageHeader.trim() || null : null,
          imageUrl: contextType === "figura" ? imageUrl.trim() || null : null,
          correct: 'a',
          correctText: "",
          correcta: 'a',
          url: null,
        };

        setQuestions((prev) => {
          if (prev.some((item) => item.id === parentQuestion.id)) {
            return prev;
          }

          return [...prev, parentQuestion];
        });
      }

      const preguntaData = {
        sectionId: selectedSection,
        texto: questionText.trim(),
        opciones: {
          a: answerA.trim(),
          b: answerB.trim(),
          c: answerC.trim(),
          d: answerD.trim(),
        },
        correcta: correctAnswer,
        type: 'question',
        contextId: groupedContext ? groupedContext.id : (hasContext ? contextId : null),
        contextType: groupedContext ? groupedContext.contextType : (hasContext ? contextType : null),
        contextText: groupedContext && groupedContext.contextType === "texto"
          ? groupedContext.contextText || null
          : hasContext && contextType === "texto"
            ? contextText.trim() || null
            : null,
        reference: groupedContext
          ? groupedContext.reference || null
          : groupedQuestion && contextType === "texto"
            ? referenceText.trim() || null
            : null,
        imageHeader: groupedContext && groupedContext.contextType === "figura"
          ? groupedContext.imageHeader || null
          : hasContext && contextType === "figura"
            ? imageHeader.trim() || null
            : null,
        imageUrl: groupedContext && groupedContext.contextType === "figura"
          ? groupedContext.imageUrl || null
          : hasContext && contextType === "figura"
            ? imageUrl.trim() || null
            : null,
        url: url.trim() || null,
      };

      const newQuestionFromDb = await crearPregunta(preguntaData);

      const newQuestion = {
        id: newQuestionFromDb.id,
        sectionId: selectedSection,
        text: questionText.trim(),
        options: preguntaData.opciones,
        type: 'question',
        contextId: preguntaData.contextId,
        contextType: preguntaData.contextType,
        contextText: preguntaData.contextText,
        reference: preguntaData.reference,
        imageHeader: preguntaData.imageHeader,
        imageUrl: preguntaData.imageUrl,
        correct: correctAnswer,
        correctText: preguntaData.opciones[correctAnswer],
        correcta: correctAnswer,
        url: preguntaData.url || null,
      };

      setQuestions((prev) => [...prev, newQuestion]);
      resetQuestionForm({ preserveContext: true, preserveSection: true });
      alert("Pregunta creada.");
    } catch (error) {
      console.error("Error al crear pregunta:", error);
      alert("Error al crear la pregunta. Intenta de nuevo.");
    } finally {
      setLoading(false);
    }
  };

  const imageOptions = useMemo(() => {
    const options = imageLibraryText
      .split(/\r?\n/)
      .map((line) => line.trim())
      .filter(Boolean);

    if (imageUrl.trim()) {
      options.unshift(imageUrl.trim());
    }

    return Array.from(new Set(options));
  }, [imageLibraryText, imageUrl]);

  const contextOptions = useMemo(() => {
    const groupedContexts = questions
      .filter((question) => question.type === 'context')
      .map((question) => ({
        id: question.id,
        label: question.contextType === 'texto'
          ? (question.contextText || 'Texto del conjunto')
          : (question.imageHeader || question.imageUrl || 'Figura del conjunto'),
        type: question.contextType,
        reference: question.reference || '',
        contextText: question.contextText || '',
        imageHeader: question.imageHeader || '',
        imageUrl: question.imageUrl || '',
        ...question,
      }));

    return groupedContexts;
  }, [questions]);

  const handleContextSelectionChange = (value) => {
    setActiveContextId(value);

    if (!value) {
      setContextText("");
      setReferenceText("");
      setImageHeader("");
      setImageUrl("");
      setSelectedImageUrl("");
      setImageLibraryText("");
      return;
    }

    const selectedContext = contextOptions.find((option) => option.id === value);
    if (!selectedContext) {
      return;
    }

    setContextType(selectedContext.contextType || 'texto');
    setContextText(selectedContext.contextText || '');
    setReferenceText(selectedContext.reference || '');
    setImageHeader(selectedContext.imageHeader || '');
    setImageUrl(selectedContext.imageUrl || '');
    setSelectedImageUrl(selectedContext.imageUrl || '');
    setImageLibraryText(selectedContext.imageUrl ? selectedContext.imageUrl : '');
  };

  const questionGroups = useMemo(() => {
    const grouped = [];
    const lookup = new Map();

    questions.forEach((question) => {
      if (question.type === 'context') {
        const group = {
          ...question,
          children: [],
        };
        grouped.push(group);
        lookup.set(question.id, group);
        return;
      }

      if (question.type === 'question' && question.contextId) {
        const parent = lookup.get(question.contextId);
        if (parent) {
          parent.children.push(question);
          return;
        }
      }

      grouped.push({
        id: question.id,
        standalone: true,
        question,
      });
    });

    return grouped;
  }, [questions]);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content modal-icfes" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Modal ICFES</h3>
          <button className="btn-close" onClick={onClose}>
            X
          </button>
        </div>

        <div style={{ display: "flex", gap: "18px", flexWrap: "wrap" }}>
          <div style={{ flex: 1, minWidth: "320px" }}>
            <div style={{ display: "flex", gap: "10px", marginBottom: "18px", flexWrap: "wrap" }}>
              {Object.entries(modeLabels).map(([key, label]) => (
                <button
                  key={key}
                  type="button"
                  onClick={() => setMode(key)}
                  style={{
                    flex: 1,
                    minWidth: "110px",
                    padding: "12px 14px",
                    borderRadius: "12px",
                    border: mode === key ? "2px solid #16a34a" : "2px solid rgba(255,255,255,0.12)",
                    background: mode === key ? "rgba(22,163,74,0.12)" : "rgba(255,255,255,0.04)",
                    color: "#fff",
                    cursor: "pointer",
                    fontWeight: 700,
                  }}
                >
                  {label}
                </button>
              ))}
            </div>

            {mode === "cuadernillo" && (
              <Cuadernillo
                cuadernillos={cuadernillos}
                cuadernilloIdState={cuadernilloIdState}
                cuadernilloName={cuadernilloName}
                loading={loading}
                onSelectExistingCuadernillo={handleSelectExistingCuadernillo}
                onCuadernilloNameChange={setCuadernilloName}
                onAddCuadernillo={addCuadernillo}
              />
            )}

            {mode === "section" && (
              <Seccion
                sectionName={sectionName}
                onSectionNameChange={setSectionName}
                onAddSection={addSection}
                loading={loading}
              />
            )}

            {mode === "question" && (
              <Preguntas
                sectionOptions={sectionOptions}
                selectedSection={selectedSection}
                onSelectSection={setSelectedSection}
                questionMode={questionMode}
                onQuestionModeChange={handleQuestionModeChange}
                questionText={questionText}
                onQuestionTextChange={setQuestionText}
                contextType={contextType}
                onContextTypeChange={handleContextTypeChange}
                contextText={contextText}
                onContextTextChange={setContextText}
                reference={referenceText}
                onReferenceChange={setReferenceText}
                imageHeader={imageHeader}
                onImageHeaderChange={setImageHeader}
                imageUrl={imageUrl}
                onImageUrlChange={setImageUrl}
                imageLibraryText={imageLibraryText}
                onImageLibraryChange={handleImageLibraryChange}
                imageOptions={imageOptions}
                selectedImageUrl={selectedImageUrl}
                onImageSelectionChange={handleImageSelectionChange}
                contextOptions={contextOptions}
                selectedContextId={activeContextId}
                onContextSelectionChange={handleContextSelectionChange}
                answerA={answerA}
                onAnswerAChange={setAnswerA}
                answerB={answerB}
                onAnswerBChange={setAnswerB}
                answerC={answerC}
                onAnswerCChange={setAnswerC}
                answerD={answerD}
                onAnswerDChange={setAnswerD}
                correctAnswer={correctAnswer}
                onCorrectAnswerChange={setCorrectAnswer}
                url={url}
                onUrlChange={setUrl}
                onSubmit={editingQuestionId ? updateQuestion : addQuestion}
                onCancelEdit={cancelEditQuestion}
                editingQuestionId={editingQuestionId}
                hasSections={hasSections}
                loading={loading}
                hasCuadernillo={hasCuadernillo}
              />
            )}
          </div>

          <div style={{ flex: 1, minWidth: "320px", background: "rgba(255,255,255,0.03)", borderRadius: "22px", padding: "20px" }}>
            <h4 style={{ marginTop: 0, fontWeight: 800 }}>Resumen</h4>
            <div style={{ marginBottom: "18px" }}>
              <p style={{ margin: 0, fontWeight: 700 }}>Cuadernillo</p>
              {hasCuadernillo ? (
                <div style={{ marginTop: "8px", color: "#e5e7eb" }}>
                  <p style={{ margin: 0 }}><strong>{cuadernilloName || cuadernilloIdState}</strong></p>
                  <p style={{ margin: "4px 0 0", fontSize: "0.95rem", color: "#d1d5db" }}>
                    ID: {cuadernilloIdState}
                  </p>
                </div>
              ) : (
                <p style={{ margin: "8px 0 0", color: "#d1d5db" }}>
                  Aún no hay cuadernillo creado.
                </p>
              )}
            </div>
            <div style={{ marginBottom: "18px" }}>
              <p style={{ margin: 0, fontWeight: 700 }}>Secciones</p>
              {sections.length === 0 ? (
                <p style={{ margin: "8px 0 0", color: "#d1d5db" }}>No hay secciones creadas.</p>
              ) : (
                <ul style={{ margin: "10px 0 0", paddingLeft: "20px", color: "#e5e7eb" }}>
                  {sections.map((section) => (
                    <li key={section.id}>{section.name}</li>
                  ))}
                </ul>
              )}
            </div>

            <div>
              <p style={{ margin: 0, fontWeight: 700 }}>Preguntas</p>
              {questionGroups.length === 0 ? (
                <p style={{ margin: "8px 0 0", color: "#d1d5db" }}>No hay preguntas creadas.</p>
              ) : (
                <ul style={{ margin: "10px 0 0", paddingLeft: "20px", color: "#e5e7eb" }}>
                  {questionGroups.map((group) => {
                    const section = sections.find((sec) => sec.id === group.sectionId);

                    if (group.standalone) {
                      const question = group.question;
                      return (
                        <li key={question.id} style={{ marginBottom: "10px" }}>
                          <div style={{ display: "flex", justifyContent: "space-between", gap: "12px", alignItems: "flex-start" }}>
                            <div>
                              <strong>{question.text}</strong>
                              <div style={{ fontSize: "0.9rem", marginTop: "4px" }}>
                                Seccion: {section?.name || "-"}
                                <br />
                                Correcta: {question.correct.toUpperCase()} {question.correctText ? `- ${question.correctText}` : ""}
                                {question.url && (
                                  <><br /><a href={question.url} target="_blank" rel="noreferrer" style={{ color: "#93c5fd" }}>URL de la pregunta</a></>
                                )}
                              </div>
                            </div>
                            <button
                              type="button"
                              onClick={() => startEditingQuestion(question)}
                              style={{
                                background: "#111",
                                color: "#fff",
                                border: "none",
                                borderRadius: "10px",
                                padding: "10px 14px",
                                cursor: "pointer",
                                fontWeight: 700,
                              }}
                            >
                              Editar
                            </button>
                          </div>
                        </li>
                      );
                    }

                    const contextLabel = group.contextType === "texto" ? "Texto base" : group.contextType === "figura" ? "Figura" : "Contexto";

                    return (
                      <li key={group.id} style={{ marginBottom: "16px" }}>
                        <div style={{ marginBottom: "10px", padding: "12px", borderRadius: "12px", background: "rgba(14, 116, 144, 0.22)", border: "1px solid rgba(14, 116, 144, 0.45)" }}>
                          <div style={{ fontWeight: 800, marginBottom: "8px" }}>{contextLabel}</div>
                          {group.imageHeader && (
                            <div style={{ marginBottom: "6px" }}><strong>Encabezado:</strong> {group.imageHeader}</div>
                          )}
                          {group.reference && (
                            <div style={{ marginBottom: "6px" }}><strong>Referencia:</strong> {group.reference}</div>
                          )}
                          {group.contextType === "texto" && group.contextText && (
                            <div style={{ whiteSpace: "pre-wrap", lineHeight: 1.4, marginBottom: "8px" }}>{group.contextText}</div>
                          )}
                          {group.contextType === "figura" && group.imageUrl && (
                            <img src={group.imageUrl} alt="Figura de la pregunta" style={{ maxWidth: "100%", borderRadius: "10px" }} />
                          )}
                          <div style={{ fontSize: "0.78rem", color: "#d1fae5" }}>Referencia interna: {group.id}</div>
                        </div>
                        <ul style={{ margin: "0 0 0 16px", paddingLeft: "8px", display: "flex", flexDirection: "column", gap: "10px" }}>
                          {group.children.map((question) => (
                            <li key={question.id} style={{ listStyle: "disc" }}>
                              <div style={{ display: "flex", justifyContent: "space-between", gap: "12px", alignItems: "flex-start" }}>
                                <div>
                                  <strong>{question.text}</strong>
                                  <div style={{ fontSize: "0.9rem", marginTop: "4px" }}>
                                    Seccion: {section?.name || "-"}
                                    <br />
                                    Correcta: {question.correct.toUpperCase()} {question.correctText ? `- ${question.correctText}` : ""}
                                    {question.url && (
                                      <><br /><a href={question.url} target="_blank" rel="noreferrer" style={{ color: "#93c5fd" }}>URL de la pregunta</a></>
                                    )}
                                  </div>
                                </div>
                                <button
                                  type="button"
                                  onClick={() => startEditingQuestion(question)}
                                  style={{
                                    background: "#111",
                                    color: "#fff",
                                    border: "none",
                                    borderRadius: "10px",
                                    padding: "10px 14px",
                                    cursor: "pointer",
                                    fontWeight: 700,
                                  }}
                                >
                                  Editar
                                </button>
                              </div>
                            </li>
                          ))}
                        </ul>
                      </li>
                    );
                  })}
                </ul>
              )}
            </div>
          </div>
        </div>

        {children}
      </div>
    </div>
  );
}

export default ModalIcfes;
